(function () {
    /**
     * Meeting service is mostly responsible for handling joining to Web conference rooms.
     */
    angular.module('tradersyard').factory('WindowService', windowServiceFactory);

    windowServiceFactory.$inject = ['$localStorage'];

    function windowServiceFactory($localStorage) {
        return {
            pushWindow,
            countOpenedWindow,
        };

        function pushWindow(meetName) {
            let wins = JSON.parse(localStorage.getItem('ngStorage-wins')) || [];
            let winIdx = wins.indexOf(meetName);

            if (winIdx === -1) {
                wins.push(meetName);
                $localStorage.wins = wins;
            }
        }

        function countOpenedWindow() {
            let wins = JSON.parse(localStorage.getItem('ngStorage-wins'));

            return wins && wins.length;
        }
    }
})();
